import Validator from '../validator';
import axios from 'axios';
import ValidatePassword from "../validatePassword";

let auth = {
    popup() {
        return {
            is_on_cart_page: false,
            is_loading: false,
            validator: new Validator(),
            show: false,
            has_error: false,
            error_message: null,
            current_page: 'login',
            email: null,
            pass: null,
            email_forget: null,
            code: null,
            token_password: null,
            new_password: null,
            new_password_confirm: null,
            validatePassword: new ValidatePassword(),
            open() { this.show = true },
            close() { this.show = false },
            isOpen() { return this.show === true },
            init(is_on_cart_page) {
                this.is_on_cart_page = is_on_cart_page;
                this.$watch('current_page', (value) => {
                    this.email = this.pass = this.code = this.new_password = null;
                    this.validator.clear();
                    this.has_error = this.is_loading = false;
                    this.error_message = null;
                });
                this.$watch('new_password', (value) => {
                    this.validatePassword.setPassword(value);
                });
            },
            validateLogin() {
                this.validator.clear();
                this.has_error = false;
                this.error_message = null;

                if(!this.email) {
                    this.validator.addError('email', Drupal.t('Le champ @field_name est obligatoire.', {'@field_name': 'email'}, {context: "otio"}));
                    this.has_error = true;
                }

                if(!this.pass) {
                    this.validator.addError('pass', Drupal.t('Le champ @field_name est obligatoire.', {'@field_name': 'mot de passe'}, {context: "otio"}));
                    this.has_error = true;
                }

                if(this.email && !this.validator.validateEmail(this.email)) {
                    this.validator.addError('email', Drupal.t('Le champ @field_name doit être un email.', {'@field_name': 'email'}, {context: "otio"}));
                    this.has_error = true;
                }

                if(this.has_error)
                    this.error_message = Drupal.t('Veuillez vérifier les champs en rouge.', {}, {context: "otio"});
            },
            submitLogin() {
                this.validateLogin();

                if(this.has_error)
                    return false;

                this.is_loading = true;
                axios.post(window.drupalSettings.ek_user.api_routes.access_token, {
                    username: this.email,
                    password: this.pass
                }).then((response) => {
                    if(!this.is_on_cart_page) {
                        window.location.href = window.drupalSettings.ek_user.routes.dashboard;
                    } else {
                        window.location.href = window.drupalSettings.ek_user.routes.checkout_step1;
                    }
                }).catch((error) => {
                    this.is_loading = false;
                    console.log(error.response.data);
                    this.has_error = true;
                    this.error_message = error.response.data.error;
                });
            },
            validateForgotPassword() {
                this.validator.clear();
                this.has_error = false;
                this.error_message = null;

                if(!this.email_forget) {
                    this.validator.addError('email_forget', Drupal.t('Le champ @field_name est obligatoire.', {'@field_name': 'email'}, {context: "otio"}));
                    this.has_error = true;
                }

                if(this.email_forget && !this.validator.validateEmail(this.email_forget)) {
                    this.validator.addError('email_forget', Drupal.t('Le champ @field_name doit être un email.', {'@field_name': 'email'}, {context: "otio"}));
                    this.has_error = true;
                }

                if(this.has_error)
                    this.error_message = Drupal.t('Veuillez vérifier les champs en rouge.', {}, {context: "otio"});
            },
            submitForgotPassword() {
                this.validateForgotPassword();

                if(this.has_error)
                    return false;

                this.is_loading = true;
                axios.post(window.drupalSettings.ek_user.api_routes.forget_password, {
                    email: this.email_forget
                }).then((response) => {
                    this.current_page = 'code_change_password';
                }).catch((error) => {
                    this.is_loading = false;
                    console.log(error.response.data);
                    this.has_error = true;
                    this.error_message = error.response.data.error;
                });
            },
            validateCodeChangePassword() {
                this.validator.clear();
                this.has_error = false;
                this.error_message = null;

                if(!this.code) {
                    this.validator.addError('code', Drupal.t('Le champ @field_name est obligatoire.', {'@field_name': 'code'}, {context: "otio"}));
                    this.has_error = true;
                }

                if(this.has_error)
                    this.error_message = Drupal.t('Veuillez vérifier les champs en rouge.', {}, {context: "otio"});
            },
            submitCodeChangePassword() {
                this.validateCodeChangePassword();

                if(this.has_error)
                    return false;

                this.is_loading = true;
                axios.post(window.drupalSettings.ek_user.api_routes.code_change_password, {
                    email: this.email_forget,
                    code: this.code
                }).then((response) => {
                    this.token_password = response.data.result;
                    this.current_page = 'change_password';
                }).catch((error) => {
                    this.is_loading = false;
                    console.log(error.response.data);
                    this.has_error = true;
                    this.error_message = error.response.data.error;
                });
            },
            validateNewPassword() {
                this.validator.clear();
                this.has_error = false;
                this.error_message = null;

                if(!this.new_password) {
                    this.validator.addError('new_password', Drupal.t('Le champ @field_name est obligatoire.', {'@field_name': 'mot de passe'}, {context: "otio"}));
                    this.has_error = true;
                }

                if(this.new_password && (!this.new_password_confirm || this.new_password !== this.new_password_confirm)) {
                    this.validator.addError('new_password_confirm', Drupal.t('Le champ @field_name doit être identique.', {'@field_name': 'confirmation de mot de passe'}, {context: "otio"}));
                    this.has_error = true;
                }

                if(this.new_password && !this.validatePassword.isValid()) {
                    this.validator.addError('new_password', Drupal.t('Le champ @field_name n\'est pas correct.', {'@field_name': 'mot de passe'}, {context: "otio"}));
                    this.has_error = true;
                }

                if(this.has_error)
                    this.error_message = Drupal.t('Veuillez vérifier les champs en rouge.', {}, {context: "otio"});
            },
            submitNewPassword() {
                this.validateNewPassword();

                if(this.has_error)
                    return false;

                this.is_loading = true;
                axios.post(window.drupalSettings.ek_user.api_routes.change_password, {
                    email: this.email_forget,
                    token: this.token_password,
                    password: this.new_password
                }).then((response) => {
                    this.current_page = 'change_password_confirm';
                }).catch((error) => {
                    this.is_loading = false;
                    console.log(error.response.data);
                    this.has_error = true;
                    this.error_message = error.response.data.error;
                });
            }
        }
    },
    cart() {
        return {
            is_logged: false,
            init() {
                this.is_logged = window.drupalSettings.user.uid > 0;
            },
            canProcess() {
                if(!this.is_logged) {
                    return false;
                }
            }
        }
    }
}

export default auth;
